module.exports = __webpack_public_path__ + "static/media/CD.05be5862.svg";